// extracted by mini-css-extract-plugin
export default {"Row1":"jobs-dashboard_Row1__UIbMD","Container":"jobs-dashboard_Container__fMKbG","Disabled":"jobs-dashboard_Disabled__Xtzcs"};